import {Component, effect, inject, resource, signal} from '@angular/core';
import {CartegraphImportSettings} from '../../../../../shared/models/cartegraph.model';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CartegraphManagementService} from '../../../../../data/cartegraph/cartegraph-management.service';
import {RowWithToggleComponent} from '../../row-with-toggle/row-with-toggle.component';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-cartegraph-settings-import',
  templateUrl: './cartegraph-settings-import.component.html',
  styleUrls: ['../../../settings-fields.scss',
    '../../../settings-common.scss',
  ],
  imports: [
    ReactiveFormsModule,
    RowWithToggleComponent,
    MatProgressSpinner
  ],
})
export class CartegraphSettingsImportComponent {

  private fb = inject(FormBuilder);
  private cartegraphManagementService = inject(CartegraphManagementService);

  configurationResource = resource({
    loader: () => this.cartegraphManagementService.getConfiguration()
  });

  isSaving = signal(false);
  uiError: string;
  form: FormGroup;

  constructor() {
    // create form
    this.form = this.fb.group({
      enabled: this.fb.control(null),
    });

    // register changes
    this.form.valueChanges.subscribe(formValue => {
      const {enabled} = formValue;
      const settings = Object.assign(new CartegraphImportSettings(), {enabled});
      this.saveImport(settings);
    });

    // on load of config update the form
    effect(() => {
      const config = this.configurationResource.value();
      if (!config) {
        return;
      }
      this.form.controls['enabled'].patchValue(config?.data?.settings?.import?.enabled || true, {emitEvent: false});
    });

    effect(() => {
      const saving = this.isSaving();
      if (saving) {
        this.form.controls['enabled'].disable({emitEvent: false});
      } else {
        this.form.controls['enabled'].enable({emitEvent: false});
      }
    });

  }

  private saveImport(settings: CartegraphImportSettings & { enabled: any }) {
    this.uiError = null;
    this.isSaving.set(true);
    this.cartegraphManagementService.updateImport(settings).then(response => {
      if (!!response.error) {
        this.uiError = response.error;
      }
    }).catch(error => {
      console.warn(error);
      this.uiError = error;
    }).finally(() => {
      this.isSaving.set(false);
    });
  }

}
